import React, { useState } from 'react'
import './BusinessInternet.scss'
import BusinessInternetCard from './BusinessInternetCard/BusinessInternetCard';
import Form from '../../General/Form/Form';

/*
  Четыре скорости. Слайдера нет: на десктопе все четыре видны сразу,
  на узком экране это лента со снапом.
*/
const BusinessInternet = ({data}) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <div className='businessInternet_container' id='internet'>
      <div className="businessInternet_block">
        <h2>Выберите интернет для вашего бизнеса</h2>
        <div className="businessInternet_item">
          {data?.map((i)=>
            <BusinessInternetCard key={i.id} img={i.img} title={i.title} text={i.text} show={setShowModal}/>
          )}
        </div>
      </div>
      {
        showModal &&
      <div className="form_container">
        <div className="form_block">
          <Form show={showModal} setShowModal={setShowModal} id={679} endpoint={'add_deal_b2b'}/>
        </div>
      </div>
      }
    </div>
  )
}

export default BusinessInternet
